import { render, staticRenderFns } from "./CrmMultiOrg.vue?vue&type=template&id=522a1425&"
import script from "./CrmMultiOrg.vue?vue&type=script&lang=js&"
export * from "./CrmMultiOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports